import React from "react";
import classNames from "classnames";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import useWhatsApp from "@/features/whatsapp";
import CustomerServiceEntryIcon from "@/features/whatsapp/CustomerServiceEntryIcon";

interface WalletHelpButtonProps {
  className?: string;
}

const WalletHelpButton = ({ className }: WalletHelpButtonProps) => {
  const { t } = useTranslationPlus("CustomerService");
  const { getCustomerServiceUrl, openCustomerService } = useWhatsApp();
  const customerServiceUrl = getCustomerServiceUrl();

  if (!customerServiceUrl) {
    return null;
  }

  const helpLabel = t("whatsapp_customer");

  return (
    <button
      type="button"
      className={classNames("wallet-help-button", className)}
      aria-label={helpLabel}
      onClick={() => {
        openCustomerService(customerServiceUrl);
      }}
    >
      <span className="wallet-help-button-content">
        <CustomerServiceEntryIcon width={20} height={20} />
        <span>{helpLabel}</span>
      </span>
    </button>
  );
};

export default WalletHelpButton;
